import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';

@Component({
  selector: 'spb-mark-complete-button',
  templateUrl: './mark-complete-button.component.html',
  styleUrls: ['./mark-complete-button.component.scss'],
})
export class MarkCompleteButtonComponent {
  @HostBinding('class.spb-mark-complete-button') hostBaseClass = true;
  @Input() buttonState = 'EN';
  @Output() buttonClick: EventEmitter<any> = new EventEmitter();

  updateState() {
    this.buttonState = this.buttonState === 'EN' ? 'CO' : 'EN';
    this.buttonClick.emit({state: this.buttonState});
  }
}
